export default async function polyfills() {
	if ('fetch' in window && 'CustomEvent' in window && 'HTMLPictureElement' in window && 'Promise' in window) {
		return;
	}

	if (console && 'log' in console) {
		console.log(`No window.fetch, window.CustomEvent or 'HTMLPictureElement' in window. Loading polyfills.`);
	}

	// @ts-ignore
	await import(/* webpackChunkName: "polyfill" */ './vendor/polyfill/polyfill.js');
}
